<template>
  <div>
    <div
      class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-flex">
        <div class="col-sm-10">
          <h1 class="h2 text-muted">MAPPING ENGINE / ADD LOOKUP TABLE</h1>
        </div>

        <div class="col-sm-2" style="text-align: right;">
          <button
            type="button"
            class="btn btn-danger"
            @click="$router.push('/lookup')"
          >
            Discard
          </button>
          <div class="divider" />
          <button
            class="btn btn-primary"
            type="submit"
            form="form_id"
            id="savebut"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger" role="alert">
      Error: {{ reason }}
    </div>
    <div class="row">
      <div class="col-sm-7">
        <form
          ref="form"
          id="form_id"
          class="row g-3 needs-validation"
          novalidate
          @submit.prevent="addLookup"
        >
          <div>
            <label class="form-label">Lookup Table Name</label>
            <input
              type="text"
              class="form-control"
              v-model="tableName"
              required
            />
            <div class="invalid-feedback">
              Lookup Table Name is required!
            </div>
          </div>
          <div>
            <label class="form-label">Insurer</label>
            <select class="form-select" v-model="insurerId" required>
              <option
                v-for="insurer in insurers"
                v-bind:value="insurer.insurer_id"
                :key="insurer.insurer_id"
              >
                {{ insurer.insurer_name }}
              </option>
            </select>
            <div class="invalid-feedback">
              Insurer is required!
            </div>
          </div>
        </form>
      </div>
      <div class="col-sm-5">
        <label class="form-label">
          Matching options
        </label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="matchCaseInsensitive"
          />
          <label class="form-check-label">
            Case Insensitive matching
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="matchStripSpaces"
          />
          <label class="form-check-label">
            Strip Spaces when matching
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="matchPartial"
          />
          <label class="form-check-label">
            Match any part of the lookup value
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input cb"
            type="checkbox"
            value="first"
            id="first"
            @change="cbChange('first')"
          />
          <label class="form-check-label">
            <div class="d-flex">
              Match first &nbsp;
              <input
                type="text"
                class="form-control form-control-sm"
                style="width: 10%; height: 1.5rem; padding: 0rem 0rem; min-height: 0;"
                v-model="matchFirstCount"
              />
              &nbsp; characters only
            </div>
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input cb"
            type="checkbox"
            value="last"
            id="last"
            @change="cbChange('last')"
          />
          <label class="form-check-label">
            <div class="d-flex">
              Match last &nbsp;
              <input
                type="text"
                class="form-control form-control-sm"
                style="width: 10%; height: 1.5rem; padding: 0rem 0rem; min-height: 0;"
                v-model="matchLastCount"
              />
              &nbsp; characters only
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../config";
export default {
  data() {
    return {
      insurers: [],
      tableName: "",
      insurerId: "",
      matchCaseInsensitive: false,
      matchStripSpaces: false,
      matchPartial: false,
      matchChars: "",
      matchFirstCount: null,
      matchLastCount: null,
      error: false,
      reason: "",
    };
  },
  methods: {
    cbChange(obj) {
      var instate = document.getElementById(obj).checked;
      var cbs = document.getElementsByClassName("cb");
      for (var i = 0; i < cbs.length; i++) {
        cbs[i].checked = false;
      }
      if (instate) document.getElementById(obj).checked = true;
    },
    async addLookup() {
      const form = document.getElementById("form_id");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              table_name: this.tableName,
              insurer_id: this.insurerId,
              match_case_insensitive: this.matchCaseInsensitive,
              match_strip_spaces: this.matchStripSpaces,
              match_partial: this.matchPartial,
              match_first_chars: document.getElementById("first").checked,
              match_last_chars: document.getElementById("last").checked,
              match_char_count: document.getElementById("first").checked
                ? this.matchFirstCount
                : document.getElementById("last").checked
                ? this.matchLastCount
                : null,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/add_lookup_table",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) this.$router.push("/lookup");
        else {
          this.error = true;
          this.reason = data["reason"];
        }
      }
    },
    async getDeets() {
      const ires = await fetch(config.baseURL + "/get_insurers", {
        credentials: "include",
      });
      const idata = await ires.json();
      this.insurers = idata;
    },
  },
  mounted() {
    this.getDeets();
    const form = document.getElementById("form_id");
    form.addEventListener(
      "submit",
      function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
  },
};
</script>

<style scoped>
.divider {
  width: 10px;
  height: auto;
  display: inline-block;
}
</style>
